import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { Button, Form, Modal } from 'react-bootstrap';
import Select from 'react-select';
import { StyleSheet, css } from 'aphrodite';
import ToggleSwitch from 'react-switch';

import { grape } from 'lib/css/colors';
import {
  USER_TIME_LOG_GET_CONFIGURATIONS,
  USER_TIME_LOG_SET_CONFIGURATIONS,
} from 'lib/networking/endpoints';
import LoadingSpinner from 'components/shared/LoadingSpinner';
import { spinnerOverlayGrey } from 'lib/css/colors';
import useGet from 'lib/hooks/useGet';
import usePost from 'lib/hooks/usePost';
import {
  formatDateAsString,
  getCycleByStartDate,
  weeklyCycles,
} from 'components/settings/user_time_logs/UserTimeLogUtils';

function UserTimeLogsConfigModal({ onHide }) {
  const [enable48HoursWindow, setEnable48HoursWindow] = useState(null);
  const [selectedCycle, setSelectedCycle] = useState(null);
  const { data: enable48HoursWindowData, isLoading: isLoadingEnable48HoursWindow } = useGet(
    USER_TIME_LOG_GET_CONFIGURATIONS,
  );

  useEffect(() => {
    if (enable48HoursWindowData) {
      setEnable48HoursWindow(enable48HoursWindowData.is_48_hours_window_enabled);
      setSelectedCycle(getCycleByStartDate(enable48HoursWindowData.payment_cycle_start_date));
    }
  }, [enable48HoursWindowData]);

  const { postData: updateUserTimeLogConfig, loading: UpdatingUserTimeLogConfig } = usePost(
    USER_TIME_LOG_SET_CONFIGURATIONS,
  );
  return (
    <Modal show={true} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>User Time Logs Config</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <>
          {(UpdatingUserTimeLogConfig || isLoadingEnable48HoursWindow) && (
            <div className={css(styles.spinnerOverlay)}>
              <LoadingSpinner />
            </div>
          )}
          <Form>
            <Form.Group>
              <Form.Label>Enable 48 Hours Window</Form.Label>
              <ToggleSwitch
                checked={enable48HoursWindow}
                onColor={grape}
                checkedIcon={false}
                uncheckedIcon={false}
                onChange={() => setEnable48HoursWindow(!enable48HoursWindow)}
                className="ml-2"
              />
            </Form.Group>
          </Form>
          <Form>
            <Form.Group>
              <Form.Label>Payment cycle</Form.Label>
              <Select
                value={selectedCycle}
                options={weeklyCycles}
                onChange={cycle => setSelectedCycle(cycle)}
                className="basic-single"
                classNamePrefix="select"
              />
            </Form.Group>
          </Form>
        </>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="primary"
          onClick={() =>
            updateUserTimeLogConfig({
              enable_48_hours_window: enable48HoursWindow,
              payment_cycle_start_date: selectedCycle
                ? formatDateAsString(selectedCycle.value)
                : null,
            })
          }
          disabled={UpdatingUserTimeLogConfig}
        >
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

const styles = StyleSheet.create({
  spinnerOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    backgroundColor: spinnerOverlayGrey,
    zIndex: 1,
  },
});

UserTimeLogsConfigModal.propTypes = {
  onHide: PropTypes.func.isRequired,
};

export default UserTimeLogsConfigModal;
